import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AppDispatch, RootState} from "../../../app/store";
import { trendsFilter } from "./trendsTypes";
import { analyseAnfrage } from "../../../utils/apiTypes";
import { getWithAuth } from "../../../utils/api";
import { logError } from "../../../utils/utils";
import { errorHandler } from "../../../utils/errorHandling";

const initialState: trendsFilter
    = {
    calculatedTrendsList: [],
    loadingCalculatedTrends: false,
    selectedCalculatedTrend: {} as analyseAnfrage,

    groesserKleinerListe: ["Größer (>)", "Kleiner (<)"],

    aktueller: "Größer (>)",
    aktuellerTemp: "Größer (>)",
    aktuellerVorher: "Größer (>)",
    aktuellerWert: 0,
    aktuellerWertTemp: 0,
    aktuellerWertVorher: 0,
    isAktuellerAktiv: false,
  
    aktuellerAnstieg: "Größer (>)",
    aktuellerAnstiegTemp: "Größer (>)",
    aktuellerAnstiegVorher: "Größer (>)",
    aktuellerAnstiegWert: 0,
    aktuellerAnstiegWertTemp: 0,
    aktuellerAnstiegWertVorher: 0,
    isAktuellerAnstiegAktiv: false,
  
    aktuellerAnstiegsdauer: "Größer (>)",
    aktuellerAnstiegsdauerTemp: "Größer (>)",
    aktuellerAnstiegsdauerVorher: "Größer (>)",
    aktuellerAnstiegsdauerWert: 0,
    aktuellerAnstiegsdauerWertTemp: 0,
    aktuellerAnstiegsdauerWertVorher: 0,
    isAktuellerAnstiegsdauerAktiv: false,
  
    mittlererAnstieg: "Größer (>)",
    mittlererAnstiegTemp: "Größer (>)",
    mittlererAnstiegVorher: "Größer (>)",
    mittlererAnstiegWert: 0,
    mittlererAnstiegWertTemp: 0,
    mittlererAnstiegWertVorher: 0,
    isMittlererAnstiegAktiv: false,

    isChangedTrends: false,
    isFirstInitLoad: true,
}

const trendsFilterSlice = createSlice({
    name: "trendsFilter",
    initialState,
    reducers: {
        setCalculatedTrendsList: (state, action: PayloadAction<Array<analyseAnfrage>>) => {
          state.calculatedTrendsList = action.payload;
        },
        setLoadingCalculatedTrends: (state, action: PayloadAction<boolean>) => {
          state.loadingCalculatedTrends = action.payload;
        },
        setSelectedCalculatedTrend: (state, action: PayloadAction<analyseAnfrage>) => {
          state.selectedCalculatedTrend = action.payload;
        },
        setAktuellerTemp: (state, action: PayloadAction<string>) => {
            state.aktuellerTemp = action.payload;
        },
        setAktueller: (state) => {
            state.aktueller = state.aktuellerTemp;
            state.aktuellerVorher = state.aktuellerTemp;
        },
        resetAktueller: (state) => {
            state.aktueller = state.aktuellerVorher;
            state.aktuellerTemp = state.aktuellerVorher;
        },
        setAktuellerWertTemp: (state, action: PayloadAction<number>) => {
            state.aktuellerWertTemp = action.payload;
        },
        setAktuellerWert: (state) => {
            state.aktuellerWert = state.aktuellerWertTemp;
            state.aktuellerWertVorher = state.aktuellerWertTemp;
        },
        resetAktuellerWert: (state) => {
            state.aktuellerWert = state.aktuellerWertVorher;
            state.aktuellerWertTemp = state.aktuellerWertVorher;
        },

        setAktuellerAnstiegTemp: (state, action: PayloadAction<string>) => {
            state.aktuellerAnstiegTemp = action.payload;
        },
        setAktuellerAnstieg: (state) => {
            state.aktuellerAnstieg = state.aktuellerAnstiegTemp;
            state.aktuellerAnstiegVorher = state.aktuellerAnstiegTemp;
        },
        resetAktuellerAnstieg: (state) => {
            state.aktuellerAnstieg = state.aktuellerAnstiegVorher;
            state.aktuellerAnstiegTemp = state.aktuellerAnstiegVorher;
        },
        setAktuellerAnstiegWertTemp: (state, action: PayloadAction<number>) => {
            state.aktuellerAnstiegWertTemp = action.payload;
        },
        setAktuellerAnstiegWert: (state) => {
            state.aktuellerAnstiegWert = state.aktuellerAnstiegWertTemp;
            state.aktuellerAnstiegWertVorher = state.aktuellerAnstiegWertTemp;
        },
        resetAktuellerAnstiegWert: (state) => {
            state.aktuellerAnstiegWert = state.aktuellerAnstiegWertVorher;
            state.aktuellerAnstiegWertTemp = state.aktuellerAnstiegWertVorher;
        },

        setAktuellerAnstiegsdauerTemp: (state, action: PayloadAction<string>) => {
            state.aktuellerAnstiegsdauerTemp = action.payload;
        },
        setAktuellerAnstiegsdauer: (state) => {
            state.aktuellerAnstiegsdauer = state.aktuellerAnstiegsdauerTemp;
            state.aktuellerAnstiegsdauerVorher = state.aktuellerAnstiegsdauerTemp;
        },
        resetAktuellerAnstiegsdauer: (state) => {
            state.aktuellerAnstiegsdauer = state.aktuellerAnstiegsdauerVorher;
            state.aktuellerAnstiegsdauerTemp = state.aktuellerAnstiegsdauerVorher;
        },
        setAktuellerAnstiegsdauerWertTemp: (state, action: PayloadAction<number>) => {
            state.aktuellerAnstiegsdauerWertTemp = action.payload;
        },
        setAktuellerAnstiegsdauerWert: (state) => {
            state.aktuellerAnstiegsdauerWert = state.aktuellerAnstiegsdauerWertTemp;
            state.aktuellerAnstiegsdauerWertVorher = state.aktuellerAnstiegsdauerWertTemp;
        },
        resetAktuellerAnstiegsdauerWert: (state) => {
            state.aktuellerAnstiegsdauerWert = state.aktuellerAnstiegsdauerWertVorher;
            state.aktuellerAnstiegsdauerWertTemp = state.aktuellerAnstiegsdauerWertVorher;
        },
        setMittlererAnstiegTemp: (state, action: PayloadAction<string>) => {
            state.mittlererAnstiegTemp = action.payload;
        },
        setMittlererAnstieg: (state) => {
            state.mittlererAnstieg = state.mittlererAnstiegTemp;
            state.mittlererAnstiegVorher = state.mittlererAnstiegTemp;
        },
        resetMittlererAnstieg: (state) => {
            state.mittlererAnstieg = state.mittlererAnstiegVorher;
            state.mittlererAnstiegTemp = state.mittlererAnstiegVorher;
        },
        setMittlererAnstiegWertTemp: (state, action: PayloadAction<number>) => {
            state.mittlererAnstiegWertTemp = action.payload;
        },
        setMittlererAnstiegWert: (state) => {
            state.mittlererAnstiegWert = state.mittlererAnstiegWertTemp;
            state.mittlererAnstiegWertVorher = state.mittlererAnstiegWertTemp;
        },
        resetMittlererAnstiegWert: (state) => {
            state.mittlererAnstiegWert = state.mittlererAnstiegWertVorher;
            state.mittlererAnstiegWertTemp = state.mittlererAnstiegWertVorher;
        },
        
        setIsChangedTrends: (state, action: PayloadAction<boolean>) => {
            state.isChangedTrends = action.payload;
        },
        setIsFirstInitLoad: (state, action: PayloadAction<boolean>) => {
            state.isFirstInitLoad = action.payload;
        },
        setIsAktuellerAktiv: (state, action: PayloadAction<boolean>) => {
            state.isAktuellerAktiv = action.payload;
        },
        setIsAktuellerAnstiegAktiv: (state, action: PayloadAction<boolean>) => {
            state.isAktuellerAnstiegAktiv = action.payload;
        },
        setIsAktuellerAnstiegsdauerAktiv: (state, action: PayloadAction<boolean>) => {
            state.isAktuellerAnstiegsdauerAktiv = action.payload;
        },
        setIsMittlererAnstiegAktiv: (state, action: PayloadAction<boolean>) => {
            state.isMittlererAnstiegAktiv = action.payload;
        },
    }
});



// Selectors

export const selectCalculatedTrendsList = (state: RootState): Array<analyseAnfrage> => state.trendsFilter.calculatedTrendsList;
export const selectLoadingCalculatedTrends = (state: RootState): boolean => state.trendsFilter.loadingCalculatedTrends;
export const selectselectedCalculatedTrend = (state: RootState): analyseAnfrage => state.trendsFilter.selectedCalculatedTrend;

export const selectGroesserKleinerListe = (state: RootState): string[] => state.trendsFilter.groesserKleinerListe;
export const selectAktueller = (state: RootState): string => state.trendsFilter.aktueller;
export const selectAktuellerTemp = (state: RootState): string => state.trendsFilter.aktuellerTemp;
export const selectAktuellerWert = (state: RootState): number => state.trendsFilter.aktuellerWert;
export const selectAktuellerWertTemp = (state: RootState): number => state.trendsFilter.aktuellerWertTemp;
export const selectIsAktuellerAktiv = (state: RootState): boolean => state.trendsFilter.isAktuellerAktiv;

export const selectAktuellerAnstieg = (state: RootState): string => state.trendsFilter.aktuellerAnstieg;
export const selectAktuellerAnstiegTemp = (state: RootState): string => state.trendsFilter.aktuellerAnstiegTemp;
export const selectAktuellerAnstiegWert = (state: RootState): number => state.trendsFilter.aktuellerAnstiegWert;
export const selectAktuellerAnstiegWertTemp = (state: RootState): number => state.trendsFilter.aktuellerAnstiegWertTemp;
export const selectIsAktuellerAnstiegAktiv = (state: RootState): boolean => state.trendsFilter.isAktuellerAnstiegAktiv;

export const selectAktuellerAnstiegsdauer = (state: RootState): string => state.trendsFilter.aktuellerAnstiegsdauer;
export const selectAktuellerAnstiegsdauerTemp = (state: RootState): string => state.trendsFilter.aktuellerAnstiegsdauerTemp;
export const selectAktuellerAnstiegsdauerWert = (state: RootState): number => state.trendsFilter.aktuellerAnstiegsdauerWert;
export const selectAktuellerAnstiegsdauerWertTemp = (state: RootState): number => state.trendsFilter.aktuellerAnstiegsdauerWertTemp;
export const selectIsAktuellerAnstiegsdauerAktiv = (state: RootState): boolean => state.trendsFilter.isAktuellerAnstiegsdauerAktiv;

export const selectMittlererAnstieg = (state: RootState): string => state.trendsFilter.mittlererAnstieg;
export const selectMittlererAnstiegTemp = (state: RootState): string => state.trendsFilter.mittlererAnstiegTemp;
export const selectMittlererAnstiegWert = (state: RootState): number => state.trendsFilter.mittlererAnstiegWert;
export const selectMittlererAnstiegWertTemp = (state: RootState): number => state.trendsFilter.mittlererAnstiegWertTemp;
export const selectIsMittlererAnstiegAktiv = (state: RootState): boolean => state.trendsFilter.isMittlererAnstiegAktiv;

export const isChangedTrends = (state: RootState): boolean => state.trendsFilter.isChangedTrends;
export const selectIsFirstInitLoad = (state: RootState): boolean => state.trendsFilter.isFirstInitLoad


// Actions
export const {
    setCalculatedTrendsList,
    setLoadingCalculatedTrends,
    setSelectedCalculatedTrend,

    setAktueller,
    setAktuellerTemp,
    setAktuellerWert,
    setAktuellerWertTemp,
    resetAktueller,
    resetAktuellerWert,
    setIsAktuellerAktiv,

    setAktuellerAnstieg,
    setAktuellerAnstiegTemp,
    setAktuellerAnstiegWert,
    setAktuellerAnstiegWertTemp,
    resetAktuellerAnstieg,
    resetAktuellerAnstiegWert,
    setIsAktuellerAnstiegAktiv,
    
    setAktuellerAnstiegsdauer,
    setAktuellerAnstiegsdauerTemp,
    setAktuellerAnstiegsdauerWert,
    setAktuellerAnstiegsdauerWertTemp,
    resetAktuellerAnstiegsdauer,
    resetAktuellerAnstiegsdauerWert,
    setIsAktuellerAnstiegsdauerAktiv,
    
    setMittlererAnstieg,
    setMittlererAnstiegTemp,
    setMittlererAnstiegWert,
    setMittlererAnstiegWertTemp,
    resetMittlererAnstieg,
    resetMittlererAnstiegWert,
    setIsMittlererAnstiegAktiv,
    setIsChangedTrends,
    setIsFirstInitLoad
} = trendsFilterSlice.actions;


    export const getCalculatedTrends = (idString: string | undefined) => (dispatch: AppDispatch): void => {
      dispatch(setLoadingCalculatedTrends(true));
      getWithAuth("TRENDSLIST", {})
        .then((response: Array<analyseAnfrage>) => {
          if (idString) {
              const id = Number(idString);
              const entry = response.find(x => x.id == id);
              if (entry) dispatch(setSelectedCalculatedTrend(entry));
          }
          dispatch(setCalculatedTrendsList(response));
        })
        .catch((error) => {
          logError(error);
          errorHandler(error, dispatch);
        }).finally(() => dispatch(setLoadingCalculatedTrends(false)));
    }

export default trendsFilterSlice.reducer;




